export default __webpack_public_path__ + "static/media/sl.55cbefb8.svg";